import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IFormRadio, IFormRadioOption } from '../../_shared/models/form/form-radio.model';
import { FormElementBase } from '../_directives/form-element-base.directive';
import { ReactiveFormsModule } from '@angular/forms';

import { RadioComponent } from '../../radio/radio.component';

@Component({
    selector: 'sirius-form-radio',
    templateUrl: './form-radio.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, RadioComponent]
})
export class FormRadioComponent extends FormElementBase implements OnInit {
    config?: IFormRadio;

    @Input() options: IFormRadioOption[] = [];

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.label = this.config.label;
            this.formFieldDependencies = this.config.dependentFormFieldComponents;
            this.validation = this.config.validation;
            this.form = this.config.form;
            this.identifier = this.config.identifier ?? '';
            this.options = this.config.options;
        }
    }
}
